export class SelectOption {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(public label: string, public value: any) {}
}
